module.exports = __webpack_public_path__ + "img/tekenaja.bbfc9d70.webp";